import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 13H20M4 17H13" vectorEffect="non-scaling-stroke" />
		<Path d="M10.25 9.25H4.75V7.25C4.75 6.69772 5.19772 6.25 5.75 6.25H9.25C9.80228 6.25 10.25 6.69772 10.25 7.25V9.25Z" fill="currentColor" vectorEffect="non-scaling-stroke" />
		<Path d="M13.75 10L13.75 7.25C13.75 6.69772 14.1977 6.25 14.75 6.25H18.25C18.8023 6.25 19.25 6.69772 19.25 7.25V10" vectorEffect="non-scaling-stroke" />
	</SVG>
);
